module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"number":"Номер машины:","registeredSpeedKMPH":"Зарегистрированная скорость, км/ч:","allowedSpeedKMPH":"Разрешенная скорость, км/ч:","registeredAt":"Время регистрации:"},"en":{"number":"Car number:","registeredSpeedKMPH":"Registered speed, km/h:","allowedSpeedKMPH":"Allowed speed, km/h:","registeredAt":"Registered at:"}}')
  delete Component.options._Ctor
}
